

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserInsert, UserUpdate, UserUpdateImage, get_AdminSingleData } from '../../../store/actions/CommanAction';
import swal from 'sweetalert';
import { setAdminId } from '../../../store/Action_Types';
import profile_icon from '../../../icons/flaticon/profile_icon.png';

const AdminUser = ({ onUserUpdated }) => {
  const dispatch = useDispatch();
  const AdminID = useSelector((state) => state.feedBackReducer.AdminID);
  const AdminSingleData = useSelector((state) => state.feedBackReducer.AdminSingleData);

  const [file, setFile] = useState(null);
  const [passwordShown, setPasswordShown] = useState(false);
  const [formData, setFormData] = useState({
    UserName: '',
    MobileNo: '',
    AltMobileNo: '',
    password: '',
    AadharNo: '',
    Address: '',
    CreatedByUser: 1,
    isSuperAdmin: false,
    id: '',
    Photourl: '',
    FullName: '',
    designation: ''
  });

  const [IsActive, setIsActive] = useState(true);
  const [Admin, setAdminID] = useState('')
  const [EditValue, setEditValue] = useState()
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [loading, setloading] = useState(false);

  const issuperadmin1 = JSON.parse(localStorage.getItem('issuperadmin') || 'false');
  const issuperadmin = !issuperadmin1;

  useEffect(() => {
    setAdminID(AdminID);

    if (AdminID) { dispatch(get_AdminSingleData(AdminID)) }
  }, [AdminID])

  useEffect(() => {
    if (AdminID) {
      dispatch(get_AdminSingleData(AdminID));
    } else {
      setFormData({
        UserName: "",
        MobileNo: "",
        AltMobileNo: "",
        password: "",
        AadharNo: "",
        Address: "",
        CreatedByUser: 1,
        isSuperAdmin: false,
        id: "",
        Photourl: "",
        FullName: "",
        designation: ""
      });
    }
  }, [AdminID, dispatch]);

  useEffect(() => {
    if (AdminSingleData && AdminSingleData.length > 0) {
      setFormData({
        UserName: AdminSingleData[0]?.UserName || "",
        MobileNo: AdminSingleData[0]?.MobileNo || "",
        FullName: AdminSingleData[0]?.FullName || "",
        AltMobileNo: AdminSingleData[0]?.AltMobileNo || "",
        password: AdminSingleData[0]?.Password || "",
        AadharNo: AdminSingleData[0]?.AadharNo || "",
        Address: AdminSingleData[0]?.Address || "",
        CreatedByUser: AdminSingleData[0]?.CreatedByUser || 1,
        isSuperAdmin: AdminSingleData[0]?.IsSuperAdmin || false,
        id: AdminSingleData[0]?.ID || "",
        Photourl: AdminSingleData[0]?.Photourl || "",
        designation: AdminSingleData[0]?.designation || ""
      });
    }
  }, [AdminSingleData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      setFormData(prev => ({
        ...prev,
        Photourl: file.name,
      }));
    }
  };

  const handleUploadClick = async () => {
    if (!file) return;

    const formPayload = new FormData();
    formPayload.append("Data", JSON.stringify({
      ModifiedByUser: formData.CreatedByUser,
      Id: formData.id || 0,
    }));
    formPayload.append("File", file);

    try {
      await dispatch(UserUpdateImage(formPayload));
      swal("Success", "Image successfully uploaded", "success");
    } catch (error) {
      swal("Error", "Failed to upload image", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formPayload = new FormData();
    const dataObject = { ...formData };

    formPayload.append('Data', JSON.stringify(dataObject));
    if (file) {
      formPayload.append('File', file);
    }

    try {
      if (AdminID) {
        await dispatch(UserUpdate(formData));
      } else {
        await dispatch(UserInsert(formPayload));
      }
      swal('Success', `User ${AdminID ? 'updated' : 'created'} successfully!`, 'success');
      if (onUserUpdated) {
        onUserUpdated();
      }
    } catch (error) {
      swal('Error', 'An error occurred. Please try again.', 'error');
    }
  };

  const togglePassword = (e) => {
    e.preventDefault();
    setPasswordShown(!passwordShown);
  };

  return (
    <div className="container mt-0">
      <div className="row ">
        <div className="col-xl 12">
          <form onSubmit={handleSubmit}>
            <div className="row">

              <div className="col-md-9">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3 ">
                    <label htmlFor="" className='label-name'>Name</label>
                    <input
                      type="text"
                      name="FullName"
                      value={formData.FullName}
                      onChange={handleInputChange}
                      placeholder="Enter your Name"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3 ">
                    <label htmlFor="" className='label-name'>Designation</label>
                    <input
                      type="text"
                      name="designation"
                      value={formData.designation}
                      onChange={handleInputChange}
                      placeholder="Enter Designation"
                     
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3">
                    <label htmlFor="" className='label-name'>Aadhar Number</label>
                    <input
                      type="text"
                      name="AadharNo"
                      value={formData.AadharNo}
                      onChange={handleInputChange}
                      placeholder="Enter 12 digits Aadhar Number"
                      pattern="\d{12}"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3">
                    <label htmlFor="" className='label-name'>User Name</label>
                    <input
                      type="text"
                      name="UserName"
                      value={formData.UserName}
                      onChange={handleInputChange}
                      placeholder="Enter your User Name"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3" style={{ position: 'relative' }}>
                    <label htmlFor="" className='label-name'>Password</label>
                    <span
                      onClick={(e) => togglePassword(e)}
                      style={{
                        position: 'absolute', top: '58%', right: '8%', border: 'none', background: 'none', cursor: 'pointer'
                      }}
                    >
                      <i className={passwordShown ? "fa fa-eye" : "fa fa-eye-slash"}></i>
                    </span>
                    <input
                      type={passwordShown ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      style={{ WebkitTextSecurity: passwordShown ? 'none' : 'disc' }}
                      onChange={handleInputChange}
                      placeholder="Enter your Password"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3">
                    <label htmlFor="" className='label-name'>Mobile Number</label>
                    <input
                      type="tel"
                      name="MobileNo"
                      value={formData.MobileNo}
                      onChange={handleInputChange}
                      placeholder="Enter your Mobile Number"
                      pattern="[0-9]{10}"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3">
                    <label htmlFor="" className='label-name'>Alternative Number</label>
                    <input
                      type="tel"
                      name="AltMobileNo"
                      value={formData.AltMobileNo}
                      onChange={handleInputChange}
                      placeholder="Enter an Alternative Number"
                      pattern="[0-9]{10}"
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 form-group mt-3">
                    <label htmlFor="" className='label-name'>Address</label>
                    <input
                      name="Address"
                      value={formData.Address}
                      onChange={handleInputChange}
                      placeholder="Enter your Address"
                      rows="3"
                      required
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 mt-2 pt-1 d-flex align-items-center ">
                    <div className="inline-checkbox">
                      <label className=" label-name mb-0  " htmlFor="isSuperAdmin  ">Is Super Admin</label>
                      <input
                        type="checkbox"
                        style={{ borderColor: "black" }}
                        name="isSuperAdmin"
                        checked={formData.isSuperAdmin}
                        onChange={handleInputChange}
                        className="form-check-input "
                        autoComplete="off"
                        id="isSuperAdmin"
                        disabled={issuperadmin}
                      />
                    </div>
                  </div>

                  <div className="col-12 text-end mt-3">
                    <button type="submit" className="btn btn-primary">
                      {AdminID ? 'Update' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="text-center">
                  <div className="mb-2">
                    <img
                      src={file ? URL.createObjectURL(file) : (formData.Photourl ? `https://${formData.Photourl.replace(/\\/g, "/")}` : profile_icon)}
                      alt="Profile"
                      className="img-fluid rounded-circle"
                      style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                    />
                  </div>
                  <div>
                    <input
                      type="file"
                      id="profileImage"
                      onChange={handleFileChange}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
                    <label htmlFor="profileImage" className="btn btn-sm btn-primary">
                      Change Photo
                    </label>
                    {file && (
                      <button
                        type="button"
                        className="btn btn-sm btn-success ms-2"
                        onClick={handleUploadClick}
                      >
                        Upload
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminUser;